import React, { Component } from 'react';
import { Button, FormItem, TextArea, Checkbox } from 'carbon-components-react';
import { RadioGroup, Radio } from 'react-radio-group';
import NumberFormat from 'react-number-format';
import moment from 'moment';
import { StepCard, DatePicker } from '..';
import CancelModal from '../Modal/CancelModal';
import { birthdayDatesRage } from '../../utils';

class Filters extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedValue: props.selectedValue,
      valorSentimosSuaFalta:
        (props.campaignItem && props.campaignItem.valorSentimosSuaFalta) || 100,
      valorAniversario:
        (props.campaignItem && props.campaignItem.valorAniversario) || 100,
      descricaoOutroCriterio:
        (props.campaignItem && props.campaignItem.descricaoOutroCriterio) || '',
      dataInicioFormatada:
        (props.campaignItem && props.campaignItem.dataInicio) || moment(),
      dataFimFormatada:
        (props.campaignItem && props.campaignItem.dataFim) || moment(),
      aniversarioLiberados:
        props.campaignItem && props.campaignItem.aniversarioLiberados,
      aniversarioInativos:
        props.campaignItem && props.campaignItem.aniversarioInativos,
      aniversarioBloqueados:
        props.campaignItem && props.campaignItem.aniversarioBloqueados,
      // isValid: false,
      cancelModal: false,
      isEdited: false
    };
  }

  onChangeFilter = value => {

    this.setState({ selectedValue: value, isEdited: true }, () => {
      this.cleanValues()
    });
  };

  onChangeText = event => {
    this.setState({ [event.target.id]: event.target.value, isEdited: true });
  };

  toggleCancelModal = () => {
    this.setState(prevState => ({ cancelModal: !prevState.cancelModal }));
  };

  canSave = () => {
    const {
      selectedValue,
      valorSentimosSuaFalta,
      descricaoOutroCriterio,
      valorAniversario,
      dataInicioFormatada,
      dataFimFormatada
    } = this.state;

    if (
      selectedValue === 'sentimosSuaFalta' &&
      (!valorSentimosSuaFalta || Number(valorSentimosSuaFalta) < 100)
    ) {
      return false;
    }
    if (
      selectedValue === 'felizAniversario' &&
      (!valorAniversario ||
        Number(valorAniversario) < 100 ||
        !dataInicioFormatada ||
        !dataFimFormatada)
    ) {
      return false;
    }
    if (
      selectedValue === 'outroCriterio' &&
      descricaoOutroCriterio.length < 20
    ) {
      return false;
    }
    if (!selectedValue) {
      return false;
    }

    return true;
  };

  save = async () => {
    const { saveStep } = this.props;
    const {
      selectedValue,
      valorSentimosSuaFalta,
      descricaoOutroCriterio,
      valorAniversario,
      dataInicioFormatada,
      dataFimFormatada,
      aniversarioLiberados,
      aniversarioInativos,
      aniversarioBloqueados
    } = this.state;

    await saveStep({
      [selectedValue]: true,
      valorSentimosSuaFalta,
      descricaoOutroCriterio,
      valorAniversario,
      aniversarioLiberados,
      aniversarioInativos,
      aniversarioBloqueados,
      dataInicioFormatada: moment(dataInicioFormatada).format('DD/MM/YYYY'),
      dataFimFormatada: moment(dataFimFormatada).format('DD/MM/YYYY'),
      salvouFiltros: true
    });
    this.stepCardRef.toggleContent();
  };

  cleanValues = () => {
    const {
      selectedValue,
    } = this.state;

    if ( selectedValue === 'sentimosSuaFalta') {
      this.setState({
        descricaoOutroCriterio: "",
        valorAniversario: "",
        dataInicioFormatada: "",
        dataFimFormatada: "",
        aniversarioLiberados: "",
        aniversarioInativos: "",
        aniversarioBloqueados: ""
      })
    }

    if (selectedValue === 'felizAniversario') {
      this.setState({
        valorSentimosSuaFalta: "",
        descricaoOutroCriterio: "",
        dataInicioFormatada: "",
        dataFimFormatada: ""
      });      
    }
    if (selectedValue === 'outroCriterio') {
      this.setState({
        valorSentimosSuaFalta: "",
        valorAniversario: "",
        dataInicioFormatada: "",
        dataFimFormatada: "",
        aniversarioLiberados: "",
        aniversarioInativos: "",
        aniversarioBloqueados: ""
      }); 
    }

    if(selectedValue === "melhoresClientes"){
      this.setState({
        valorSentimosSuaFalta: "",
        valorAniversario: "",
        dataInicioFormatada: "",
        dataFimFormatada: "",
        descricaoOutroCriterio: "",
        aniversarioLiberados: "",
        aniversarioInativos: "",
        aniversarioBloqueados: ""
      });
    }

    if(selectedValue === "ativos" || selectedValue === "limiteDisponivel" || selectedValue === "nuncaCompraram"){
      this.setState({
        valorSentimosSuaFalta: "",
        valorAniversario: "",
        dataInicioFormatada: "",
        dataFimFormatada: "",
        descricaoOutroCriterio: "",
        aniversarioLiberados: "",
        aniversarioInativos: "",
        aniversarioBloqueados: ""
      });
    }

  }

  requestCancel = () => {
    const { isEdited } = this.state;

    if (isEdited) {
      this.toggleCancelModal();
    } else {
      this.cancel();
    }
  };

  cancel = () => {
    const { selectedValue,campaignItem } = this.props;
    this.setState({
      selectedValue,
      isEdited: false,
      cancelModal: false
    }, () => {
      this.setState({
        selectedValue,
        valorSentimosSuaFalta:
          (campaignItem && campaignItem.valorSentimosSuaFalta) || 100,
        valorAniversario:
          (campaignItem && campaignItem.valorAniversario) || 100,
        descricaoOutroCriterio:
          (campaignItem && campaignItem.descricaoOutroCriterio) || '',
        dataInicioFormatada:
          (campaignItem && campaignItem.dataInicio) || moment(),
        dataFimFormatada:
          (campaignItem && campaignItem.dataFim) || moment(),
        aniversarioLiberados:
          campaignItem && campaignItem.aniversarioLiberados,
        aniversarioInativos:
          campaignItem && campaignItem.aniversarioInativos,
        aniversarioBloqueados:
          campaignItem && campaignItem.aniversarioBloqueados,
        // isValid: false,
        cancelModal: false,
        isEdited: false        
      })
    });
    this.stepCardRef.toggleContent();
  };

  renderDescription = () => {
    const { step, selectedValue } = this.props;

    if (selectedValue === 'sentimosSuaFalta') {
      return (
        <p className="font-size-13" style={{ color: '#36474f' }}>
          <strong>Venda mais</strong>
          {' '}
- Sentimos sua falta
        </p>
      );
    }
    if (selectedValue === 'melhoresClientes') {
      return (
        <p className="font-size-13" style={{ color: '#36474f' }}>
          <strong>Venda Mais</strong>
          {' '}
– Melhores Clientes
        </p>
      );
    }
    if (selectedValue === 'nuncaCompraram') {
      return (
        <p className="font-size-13" style={{ color: '#36474f' }}>
          <strong>Venda Mais</strong>
          {' '}
– Nunca Compraram
        </p>
      );
    }
    if (selectedValue === 'limiteDisponivel') {
      return (
        <p className="font-size-13" style={{ color: '#36474f' }}>
          <strong>Venda Mais</strong>
          {' '}
– Limite disponível
        </p>
      );
    }
    if (selectedValue === 'felizAniversario') {
      return (
        <p className="font-size-13" style={{ color: '#36474f' }}>
          <strong>Venda Mais</strong>
          {' '}
– Aniversariantes
        </p>
      );
    }
    if (selectedValue === 'ativos') {
      return (
        <p className="font-size-13" style={{ color: '#36474f' }}>
          <strong>Ativos</strong>
          {' '}
– Comunicados sobre o cartão
        </p>
      );
    }
    if (selectedValue === 'outroCriterio') {
      return (
        <p className="font-size-13" style={{ color: '#36474f' }}>
          <strong>Outro Critério</strong>
        </p>
      );
    }

    return step.description;
  };

  render() {
    const {
      selectedValue,
      valorSentimosSuaFalta,
      descricaoOutroCriterio,
      valorAniversario,
      dataInicioFormatada,
      dataFimFormatada,
      aniversarioLiberados,
      aniversarioInativos,
      aniversarioBloqueados,
      cancelModal
    } = this.state;
    const { step, campaignItem, disabled, showSave } = this.props;
    const isFinished = campaignItem && campaignItem.salvouFiltros;

    return (
      <StepCard
        onRef={ref => {
          this.stepCardRef = ref;
        }}
        title={step.title}
        description={this.renderDescription()}
        isFinished={isFinished}
        disabled={disabled}
      >
        <div className="bx--grid">
          <div className="bx--row">
            <RadioGroup
              className="bx--radio-group"
              selectedValue={selectedValue}
              onChange={this.onChangeFilter}
            >
              <div>
                <Radio
                  id="filter-1"
                  className="bx--radio-button"
                  value="sentimosSuaFalta"
                />
                <label htmlFor="filter-1" className="bx--radio-button__label">
                  <span className="bx--radio-button__appearance" />
                  <strong>Venda Mais</strong>
                  {' '}
– Sentimos sua falta
                </label>
                {selectedValue === 'sentimosSuaFalta' && (
                  <div className="h-lg-margin">
                    <div className="bx--row">
                      <div className="bx--col-xs-12 bx--col-sm-6">
                        <FormItem>
                          <label className="bx--label">
                            Disponível a partir de:
                          </label>
                          <NumberFormat
                            getInputRef={ref => {
                              this.valorSentimosSuaFaltaRef = ref;
                            }}
                            id="valorSentimosSuaFalta"
                            className="bx--text-input bx--text__input"
                            decimalSeparator=","
                            fixedDecimalScale
                            thousandSeparator="."
                            prefix="R$ "
                            placeholder="R$ 0,00"
                            value={valorSentimosSuaFalta}
                            allowNegative={false}
                            decimalScale={2}
                            onValueChange={(values, e) => {
                              this.setState({
                                [e.target.id]: values.value
                                  ? Number(values.value)
                                  : null,
                                isEdited: true
                              });
                            }}
                            onFocus={() => {
                              if (
                                !valorSentimosSuaFalta &&
                                this.valorSentimosSuaFaltaRef
                              ) {
                                this.valorSentimosSuaFaltaRef.value = '';
                              }
                            }}
                          />
                          {valorSentimosSuaFalta &&
                            Number(valorSentimosSuaFalta) < 100 && (
                              <div
                                className="bx--form-requirement"
                                style={{
                                  display: 'block',
                                  maxHeight: 'initial'
                                }}
                              >
                                Preencha um valor mínimo de R$ 100,00
                              </div>
                            )}
                        </FormItem>
                      </div>
                    </div>
                    <div className="bx--form__helper-text v-sm-margin">
                      - Status da conta liberado.
                      <br />
- Cartão do titular liberado para compra.
                      <br />
- Sem compra nos últimos 3 meses, mas realizou uma
                      compra nos últimos 12 meses.
                      <br />
- Não tem fatura em atraso, parcelamento ou rotativo
                      <br />
- Titular da conta.
                    </div>
                  </div>
                )}
              </div>
              <div>
                <Radio
                  id="filter-2"
                  className="bx--radio-button"
                  value="melhoresClientes"
                />
                <label htmlFor="filter-2" className="bx--radio-button__label">
                  <span className="bx--radio-button__appearance" />
                  <strong>Venda Mais</strong>
                  {' '}
– Melhores Clientes
                </label>
                {selectedValue === 'melhoresClientes' && (
                  <div className="h-lg-margin">
                    <div className="bx--form__helper-text v-sm-margin">
                      - Cliente com o status da conta: liberado.
                      <br />
- Cartão do titular liberado para compra.
                      <br />
- Com compra nos últimos 12 meses.
                      <br />
- Que fizeram pelo menos uma compra acima de 60% do
                      limite nos últimos 3 meses.
                      <br />
- Que utilizaram o cartão nos últimos 3 meses
                      consecutivos.
                      <br />
- Ter as 3 últimas faturas pagas integralmente(Não
                      tem fatura em atraso, parcelamento ou rotativo).
                      <br />
- Ter obrigatoriamente cadastrado um telefone
                      residencial ou celular.
                      <br />
- Titular da conta.
                      <br />
- Ter no mínimo R$100,00 disponível de limite. lojas
                      de construção não participam.
                    </div>
                  </div>
                )}
              </div>
              <div>
                <Radio
                  id="filter-3"
                  className="bx--radio-button"
                  value="nuncaCompraram"
                />
                <label htmlFor="filter-3" className="bx--radio-button__label">
                  <span className="bx--radio-button__appearance" />
                  <strong>Venda Mais</strong>
                  {' '}
– Nunca Compraram
                </label>
                {selectedValue === 'nuncaCompraram' && (
                  <div className="h-lg-margin">
                    <div className="bx--form__helper-text v-sm-margin">
                      - Cartão do titular liberado para compra.
                      <br />
- Cliente com status da conta: liberado ou inativo
                      que nunca compraram, nem no provisório.
                      <br />
- Emissão do cartão do cliente deve ser de até 24
                      meses atrás.
                      <br />
- Ter obrigatoriamente cadastrado um telefone
                      residencial ou celular.
                      <br />
- Titular da conta.
                    </div>
                  </div>
                )}
              </div>
              <div>
                <Radio
                  id="filter-4"
                  className="bx--radio-button"
                  value="limiteDisponivel"
                />
                <label htmlFor="filter-4" className="bx--radio-button__label">
                  <span className="bx--radio-button__appearance" />
                  <strong>Venda Mais</strong>
                  {' '}
– Limite disponível
                </label>
                {selectedValue === 'limiteDisponivel' && (
                  <div className="h-lg-margin">
                    <div className="bx--form__helper-text v-sm-margin">
                      - Cartão do titular liberado para compra.
                      <br />
- Cliente com o status da conta: liberado ou
                      inativo.
                      <br />
- Com compra nos últimos 3 meses.
                      <br />
- Ter no mínimo R$200,00 de limite disponível.
                      <br />
- Titular da conta.
                      <br />
- Não tem fatura em atraso, parcelamento ou
                      rotativo.
                      <br />
- Ter obrigatoriamente cadastrado um telefone
                      residencial ou celular.
                    </div>
                  </div>
                )}
              </div>
              <div>
                <Radio
                  id="filter-5"
                  className="bx--radio-button"
                  value="felizAniversario"
                />
                <label htmlFor="filter-5" className="bx--radio-button__label">
                  <span className="bx--radio-button__appearance" />
                  <strong>Venda Mais</strong>
                  {' '}
– Aniversariantes
                </label>
                {selectedValue === 'felizAniversario' && (
                  <div className="h-lg-margin">
                    <div className="bx--row">
                      <div className="bx--col-xs-12 bx--col-sm-6">
                        <FormItem className="v-sm-margin">
                          <label className="bx--label">De:</label>
                          <DatePicker
                            id="dataInicioFormatada"
                            date={dataInicioFormatada ? moment(dataInicioFormatada) : ""}
                            locale="pt"
                            onDateChange={date => {
                              this.setState({ dataInicioFormatada: date });
                            }}
                            isOutsideRange={birthdayDatesRage}
                            readOnly
                          />
                        </FormItem>
                      </div>
                      <div className="bx--col-xs-12 bx--col-sm-6">
                        <FormItem className="v-sm-margin">
                          <label className="bx--label">Até:</label>
                          <DatePicker
                            id="dataFimFormatada"
                            date={dataFimFormatada ? moment(dataFimFormatada) : ""}
                            locale="pt"
                            onDateChange={date => {
                              this.setState({ dataFimFormatada: date });
                            }}
                            isOutsideRange={day => {
                              const datesRange = birthdayDatesRage(day);
                              const isBeforeData = day.isBefore(
                                dataInicioFormatada
                              );
                              return datesRange || isBeforeData;
                            }}
                            readOnly
                          />
                        </FormItem>
                      </div>
                    </div>
                    <div className="bx--row">
                      <div className="bx--col-xs-12 bx--col-sm-6">
                        <FormItem className="v-sm-margin">
                          <label className="bx--label">
                            Disponível a partir de:
                          </label>
                          <NumberFormat
                            getInputRef={ref => {
                              this.valorAniversarioRef = ref;
                            }}
                            id="valorAniversario"
                            className="bx--text-input bx--text__input"
                            decimalSeparator=","
                            prefix="R$ "
                            fixedDecimalScale
                            thousandSeparator="."
                            placeholder="R$ 0,00"
                            value={valorAniversario}
                            allowNegative={false}
                            decimalScale={2}
                            onValueChange={(values, e) => {
                              this.setState({
                                [e.target.id]: values.value
                                  ? Number(values.value)
                                  : null,
                                isEdited: true
                              });
                            }}
                            onFocus={() => {
                              if (
                                !valorAniversario &&
                                this.valorAniversarioRef
                              ) {
                                this.valorAniversarioRef.value = '';
                              }
                            }}
                          />
                          {valorAniversario &&
                            Number(valorAniversario) < 100 && (
                              <div
                                className="bx--form-requirement"
                                style={{
                                  display: 'block',
                                  maxHeight: 'initial'
                                }}
                              >
                                Preencha um valor mínimo de R$ 100,00
                              </div>
                            )}
                        </FormItem>
                      </div>
                    </div>
                    <div className="bx--row ">
                      <div className="bx--col-xs-12 bx--col-sm-auto">
                        <FormItem className="v-sm-margin">
                          <Checkbox
                            id="aniversarioLiberados"
                            labelText="Liberados"
                            checked={aniversarioLiberados || false}
                            onChange={value => {
                              this.setState({ aniversarioLiberados: value });
                            }}
                          />
                        </FormItem>
                      </div>
                      <div className="bx--col-xs-12 bx--col-sm-auto">
                        <FormItem className="v-sm-margin">
                          <Checkbox
                            id="aniversarioInativos"
                            labelText="Inativos"
                            checked={aniversarioInativos || false}
                            onChange={value => {
                              this.setState({ aniversarioInativos: value });
                            }}
                          />
                        </FormItem>
                      </div>
                      <div className="bx--col-xs-12 bx--col-sm-auto">
                        <FormItem className="v-sm-margin">
                          <Checkbox
                            id="aniversarioBloqueados"
                            labelText="Bloqueados por Limite"
                            checked={aniversarioBloqueados || false}
                            onChange={value => {
                              this.setState({ aniversarioBloqueados: value });
                            }}
                          />
                        </FormItem>
                      </div>
                      <div className="bx--form__helper-text v-sm-margin">
                        - Cartão do titular liberado para compra.
                        <br />
- Cliente com o status da conta: liberado, inativo
                        ou bloqueado por limite.
                        <br />
- Com compra nos últimos 12 meses
                        <br />
- Mês de aniversário atual anterior e posterior
                        <br />
- Titular da conta.
                        <br />
- Ter no mínimo R$100,00 disponível de limite.
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div>
                <Radio
                  id="filter-6"
                  className="bx--radio-button"
                  value="ativos"
                />
                <label htmlFor="filter-6" className="bx--radio-button__label">
                  <span className="bx--radio-button__appearance" />
                  <strong>Ativos</strong>
– Comunicados sobre o cartão
                </label>
                {selectedValue === 'ativos' && (
                  <div className="h-lg-margin">
                    <div className="bx--form__helper-text v-sm-margin">
                      - Associado com o status da conta: liberado 
                      {' '}
                      <br />
- Status
                      do cartão Liberado e Bloqueado (cartão provisório)
                      <br />
- Com compra nos últimos 3 meses
                      <br />
- Cliente com limite disponível (sem valor
                      específico)
                      <br />
- Titular da conta.
                    </div>
                  </div>
                )}
              </div>
              <div>
                <Radio
                  id="filter-7"
                  className="bx--radio-button"
                  value="outroCriterio"
                />
                <label htmlFor="filter-7" className="bx--radio-button__label">
                  <span className="bx--radio-button__appearance" />
                  <strong>Outro critério (não contempla campanha de cobrança)</strong>
                </label>
                {selectedValue === 'outroCriterio' && (
                  <div className="h-lg-margin">
                    <div className="bx--form__helper-text v-sm-margin">
                      Escolha esse filtro apenas se a estratégia da mensagem
                      exigir um combinado de filtros específicos. Será preciso
                      informar todos os filtros necessários tais como:
                      <br />
                      <br />
- Status do associado
                      <br />
- Status do cartão
                      <br />
- Critérios comportamentais (Período de compra
                      específico, acessa ou não a canais digitais, possui ou não
                      produtos do cartão e etc.)
                      <br />
                      <br />
                      Atenção aos critérios solicitados pois esse formato pode
                      ter alto risco de impacto negativo.
                    </div>
                    <FormItem>
                      <TextArea
                        id="descricaoOutroCriterio"
                        labelText="Descreva"
                        onChange={this.onChangeText}
                        value={descricaoOutroCriterio}
                        placeholder="Exemplo: Associado com status liberado, com compra no período de 3 meses, cartão com status liberado ou bloqueado por limite, com Ecofatura, e sem acesso à Área do cliente dentro de 3 meses."
                        invalidText="Preencha uma descrição com no mínimo 20 caracteres"
                        invalid={descricaoOutroCriterio.length < 20}
                      />
                    </FormItem>
                  </div>
                )}
              </div>
            </RadioGroup>
          </div>
          <div className="bx--row">
          {!!showSave && (
            <div className="bx--col-xs-12 bx--col-sm-6 v-md-margin">
              <Button onClick={this.save} disabled={!this.canSave()}>
                Salvar
              </Button>
              <Button
                kind="ghost"
                className="h-sm-margin"
                onClick={this.requestCancel}
              >
                Cancelar
              </Button>
            </div>
            )}
          </div>
          <CancelModal
            open={cancelModal}
            onOk={this.cancel}
            onCancel={this.toggleCancelModal}
          />
        </div>
      </StepCard>
    );
  }
}

export default Filters;



// WEBPACK FOOTER //
// ./src/components/campaigns/Filters.js